import ClassNames from "classnames";
import { FunctionComponent, RefObject } from "react";
import mainMenuStyles from "../stylesheets/components/main-menu.module.css";
import {
  ColorScheme,
  Language,
  MainMenuItem,
  PageState,
} from "../types/index.js";
import MainMenuLevel from "./MainMenuLevel.js";

interface Props {
  isPreview: boolean;
  languageId: Language;
  pages: PageState;
  menuItems: MainMenuItem[];
  scheme: ColorScheme;
  activePagePath: string[];
  fallbackLanguageId: Language | undefined;
  ulRef:
    | RefObject<HTMLUListElement>
    | ((instance: HTMLUListElement | null) => void)
    | undefined;
  className: string;
  liRef?: (instance: HTMLLIElement | null, index: number) => void;
}

const SplitMainMenuList: FunctionComponent<Props> = ({
  isPreview,
  languageId,
  pages,
  menuItems,
  scheme,
  activePagePath,
  fallbackLanguageId,
  ulRef,
  className,
  liRef,
}) => (
  <ul
    className={ClassNames(className, mainMenuStyles.MainMenu__List)}
    ref={ulRef}
  >
    {menuItems.map((currentMenuItem, index) => (
      <MainMenuLevel
        key={currentMenuItem.id}
        isPreview={isPreview}
        languageId={languageId}
        parentId={currentMenuItem.id}
        pages={pages}
        currentMenuItem={currentMenuItem}
        scheme={scheme}
        menuLevel={0}
        topHeaderVariant={undefined}
        activePagePath={activePagePath}
        fallbackLanguageId={fallbackLanguageId}
        liRef={liRef && ((el) => liRef(el, index))}
        index={index}
        repeatFirstLevelItem={true}
      />
    ))}
  </ul>
);

export default SplitMainMenuList;
